// faq page stránka s často kladenými dotazy
function faqPage() {
  // otevření kategorie (tabu)
  $('.js-faq-open').on('click', function (event) {
    event.preventDefault();

    $('.faq-page__tab').hide();
    $('.js-faq-open').removeClass('is-open');
    $(this).addClass('is-open');

    // zjištění ID tabu z atributu rel
    let tabName = $(this).attr('href');

    // otevření tabu
    $(tabName).slideDown('fast');
  });

  // otevření konkrétního dotazu
  $('.faq-page__item h2').on('click', function () {
    // $(this).closest('.faq-page__item').toggleClass('is-open');
    // $(this).next('.faq-page__answer').slideDown('fast');
    if ($(this).closest('.faq-page__item').hasClass('is-open')) {
      $(this).next('.faq-page__answer').slideUp('fast');
      $(this).closest('.faq-page__item').removeClass('is-open');
    } else {
      $(this).next('.faq-page__answer').slideDown('fast');
      $(this).closest('.faq-page__item').addClass('is-open');
    }
  });

  var path = window.location.href;
  if (path.indexOf('#faq-') >= 0) {
    $('.js-faq-open').removeClass('is-open');
    $('.faq-page__tab').hide();

    var faq = path.substr(path.indexOf('#faq') + 1).split('-');
    var faqItem = faq[1];
    var faqCategory = faq[2];

    $('.js-faq-open[data-tab="' + faqCategory + '"]').addClass('is-open');
    $('#' + faqCategory)
      .addClass('is-open')
      .show();

    $('.faq-page__item').removeClass('is-open');
    $('#faq-' + faqItem + '-' + faqCategory)
      .addClass('is-open')
      .children('.faq-page__answer')
      .slideDown('fast');

    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $('#faq-' + faqItem + '-' + faqCategory).offset().top - 80,
      },
      1000
    );
  }

  //searching
  jQuery.expr[':'].icontains = function (a, i, m) {
    return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
  };

  $('#faq-input-search').keyup(function (event) {
    var value = $(this).val();
    if (value.length > 3) {
      $('.faq-page__item:not(:icontains("' + value + '"))').hide();
      var elements = $('.faq-page__item:icontains("' + value + '")');
      elements.show();
      elements.first().addClass('is-open');
      elements.first().children('.faq-page__answer').slideDown('fast');
    } else {
      $('.faq-page__item').removeClass('is-open').show();
    }
  });
}
